// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"295":"batchquery","378":"singlequery","535":"login","945":"mainlayout"}[chunkId] + "." + {"295":"414af6d4","378":"88c35a9e","535":"76d6177c","945":"713459b2"}[chunkId] + ".css";
};